module.exports = __webpack_public_path__ + "img/photography.8315f4dc.jpg";